import React from 'react';
import { useNavigate } from 'react-router-dom';

const WelcomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <nav
        style={{
          background: '#0d9488',
          height: '52px',
          display: 'flex',
          alignItems: 'center',
          padding: '0 28px',
          gap: '10px',
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: '32px',
            height: '32px',
            background: 'rgba(255,255,255,0.18)',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 700,
            fontSize: '18px',
            color: '#fff',
          }}
        >
          I
        </div>
        <span
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 700,
            fontSize: '22px',
            color: '#fff',
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
          }}
        >
          Intellerview
        </span>
      </nav>

      <main
        style={{
          flex: 1,
          background: '#f0f0eb',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'clamp(20px, 4vw, 40px)',
        }}
      >
        <div
          style={{
            background: '#ffffff',
            border: '1px solid #e2ecec',
            borderRadius: '14px',
            padding: 'clamp(52px, 8vw, 110px) clamp(28px, 7vw, 104px)',
            maxWidth: '1180px',
            width: '100%',
            minHeight: 'clamp(460px, 70vh, 760px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            boxShadow: '0 18px 45px rgba(15, 26, 26, 0.035)',
          }}
        >
          <div
            style={{
              width: '100%',
              maxWidth: '900px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: '22px',
                fontWeight: 500,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#0d9488',
                marginBottom: 'clamp(24px, 3vw, 34px)',
                display: 'block',
              }}
            >
              Employer portal
            </span>

            <h1
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 'clamp(42px, 6vw, 68px)',
                fontWeight: 700,
                color: '#0f1a1a',
                letterSpacing: '-0.03em',
                lineHeight: 1.12,
                margin: 0,
                marginBottom: 'clamp(22px, 3.5vw, 30px)',
              }}
            >
              Hard skills.{' '}
              <em style={{ color: '#0d9488', fontStyle: 'italic' }}>Verified.</em>
            </h1>

            <p
              style={{
                fontSize: 'clamp(17px, 2vw, 22px)',
                color: '#5a7070',
                fontWeight: 300,
                lineHeight: 1.8,
                margin: 0,
                marginBottom: 'clamp(42px, 5vw, 58px)',
                maxWidth: '760px',
              }}
            >
              Deploy simulations, review scored candidate results,
              <br />
              and make evidence-based hiring decisions.
            </p>

            <button
              type="button"
              onClick={() => navigate('/login?type=employer')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 'clamp(240px, 28vw, 340px)',
                background: '#0d9488',
                color: '#ffffff',
                padding: '18px 44px',
                borderRadius: '8px',
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '17px',
                fontWeight: 700,
                textDecoration: 'none',
                letterSpacing: '0.16em',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 12px 24px rgba(13, 148, 136, 0.18)',
              }}
            >
              SIGN IN
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default WelcomePage;
